import { QuantityType } from '@components/UI-Components/QuantityType/constants/QuantityType'

/**
 * map of top/totals bar ui keys
 * w.r.t Qty type
 * and API response keys
 */
export const EnhancedTotalViewKeyMap = {
  [QuantityType.Product]: {
    totalQuantity: 'totalProductQuantity',
    totalValue: 'totalProductValue'
  },
  [QuantityType.Size]: {
    totalQuantity: 'totalSizeQuantity',
    totalValue: 'totalSizeValue'
  },
  [QuantityType.Draft]: {
    totalQuantity: 'totalDoorQuantity',
    totalValue: 'totalDoorValue'
  },
  [QuantityType.DraftWHL]: {
    totalQuantity: 'totalDoorQuantity',
    totalValue: 'totalDoorValue'
  }
}

export const TotalViewKeyMap = {
  [QuantityType.Product]: {
    totalQuantity: 'totalByProductQuantity',
    totalValue: 'totalValueByProductQuantity'
  },
  [QuantityType.Size]: {
    totalQuantity: 'totalBySizeQuantity',
    totalValue: 'totalValueBySizeQuantity'
  },
  [QuantityType.Draft]: {
    totalQuantity: 'totalByDraftQuantity',
    totalValue: 'totalValueByDraftQuantity'
  },
  [QuantityType.DraftWHL]: {
    totalQuantity: 'totalByDraftQuantity',
    totalValue: 'totalValueByDraftQuantity'
  }
}

/**
 * map of KPI view ui keys
 * w.r.t Qty type
 * and API response keys
 */
export const KPIViewKeyMap = {
  [QuantityType.Product]: {
    actualMixQuantity: 'mixRatioByProductQty',
    actualMixValue: 'mixRatioByProductValue',
    totalQuantity: 'totalByProductQuantity',
    totalValue: 'totalValueByProductQuantity'
  },
  [QuantityType.Size]: {
    actualMixQuantity: 'mixRatioBySizedQty',
    actualMixValue: 'mixRatioBySizedValue',
    totalQuantity: 'totalBySizeQuantity',
    totalValue: 'totalValueBySizeQuantity'
  },
  [QuantityType.Draft]: {
    actualMixQuantity: 'mixRatioByDraftQty',
    actualMixValue: 'mixRatioByDraftValue',
    totalQuantity: 'totalByDraftQuantity',
    totalValue: 'totalValueByDraftQuantity'
  },
  [QuantityType.DraftWHL]: {
    actualMixQuantity: 'mixRatioByDraftQty',
    actualMixValue: 'mixRatioByDraftValue',
    totalQuantity: 'totalByDraftQuantity',
    totalValue: 'totalValueByDraftQuantity'
  }
}

export const EnhancedKPIViewKeyMap = {
  [QuantityType.Product]: {
    actualMixQuantity: 'mixOfProductQuantity',
    actualMixValue: 'mixOfProductValue',
    totalQuantity: 'totalProductQuantity',
    totalValue: 'totalProductValue',
    salesQuantity: 'salesQuantity',
    averageDepth: 'averageDepth',
    averageWeeklySales: 'averageWeeklySales',
    skuEff: 'skuEff'
  },
  [QuantityType.Size]: {
    actualMixQuantity: 'mixOfSizeQuantity',
    actualMixValue: 'mixOfSizeValue',
    totalQuantity: 'totalSizeQuantity',
    totalValue: 'totalSizeValue',
    salesQuantity: 'sizeSalesQuantity',
    averageDepth: 'sizeAverageDepth',
    averageWeeklySales: 'sizeAverageWeeklySales',
    skuEff: 'sizeSkuEff'
  },
  [QuantityType.Draft]: {
    actualMixQuantity: 'mixOfDoorQuantity',
    actualMixValue: 'mixOfDoorValue',
    totalQuantity: 'totalDoorQuantity',
    totalValue: 'totalDoorValue',
    salesQuantity: 'doorSalesQuantity',
    averageDepth: 'doorAverageDepth',
    averageWeeklySales: 'doorAverageWeeklySales',
    skuEff: 'doorSkuEff'
  },
  [QuantityType.DraftWHL]: {
    actualMixQuantity: 'mixOfDoorQuantity',
    actualMixValue: 'mixOfDoorValue',
    totalQuantity: 'totalDoorQuantity',
    totalValue: 'totalDoorValue',
    salesQuantity: 'doorSalesQuantity',
    averageDepth: 'doorAverageDepth',
    averageWeeklySales: 'doorAverageWeeklySales',
    skuEff: 'doorSkuEff'
  }
}
